import {useContext} from 'react'

import Context from '@s-ui/react-context'

export const useGetUrlToShare = () => {
  const {domain} = useContext(Context)
  const config = domain.get('config')
  const {SHARE} = config.get('COMMON')
  const {SHARE_PLACEHOLDERS_MAP, SHARE_METHODS_BASE_URLS} = SHARE

  const {appName: appNameKey, text: textKey, referer: refererKey, prompt: promptKey} = SHARE_PLACEHOLDERS_MAP

  return ({appName, provider, referer, text, prompt}) => {
    const getUrlToShareWithProvider = ({appName, provider, referer, text, prompt}) => {
      const url = new URL(referer)
      const refererStringWithTrackingData = url.toString()

      let urlString = SHARE_METHODS_BASE_URLS[provider]

      if (prompt && urlString.includes(promptKey)) {
        urlString = urlString.replace(promptKey, encodeURIComponent(prompt))
      } else {
        urlString = urlString
          .replace(appNameKey, appName)
          .replace(textKey, encodeURIComponent(text))
          .split(refererKey)
          .join(encodeURIComponent(refererStringWithTrackingData))
      }

      return urlString
    }

    return getUrlToShareWithProvider({
      appName,
      provider,
      referer,
      text,
      prompt
    })
  }
}
